/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {MatInput} from './input';
export {MatInputModule} from './module';
export * from './input-value-accessor';
export * from './input-errors';



// WEBPACK FOOTER //
// ../../../../../src/material/input/public-api.ts